import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Pill } from 'ui-components/components/pill';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { CellPropTypes } from '../../../../prop-types/react-table';
import { messages } from './messages';
import PropTypes from 'prop-types';

import style from './table-cells.module.less';

export const EmailVerificationStatusCell = ({ value, row, onClickVerifyEmail }) => {
  const intl = useIntl();

  const { email } = row?.original || {};

  // emailVerification is a bool?, so we need to explicitly check for undefined vs false
  //
  // undefined/null - no verification email has been sent (unverified)
  // false - verification email has been sent, but link has not been clicked (pending)
  // true - verification email has been sent and link was clicked (verified)
  if (value === undefined || value === null) {
    return (
      <Button className={style['table-cell-button']} onClick={() => onClickVerifyEmail(email)} theme={THEME_CONSTANTS.tertiary}>
        <FormattedMessage {...messages.verifyEmail} />
      </Button>
    );
  }

  const { messageDescriptor, className } = value
    ? {
        messageDescriptor: messages.verified,
        className: style['success-pill'],
      }
    : {
        messageDescriptor: messages.pending,
        className: style['neutral-pill'],
      };

  return <Pill className={className} label={intl.formatMessage(messageDescriptor)} />;
};

EmailVerificationStatusCell.propTypes = {
  ...CellPropTypes,
  onClickVerifyEmail: PropTypes.func.isRequired,
};

export const createEmailVerificationStatusColumnDefinition = (onClickVerifyEmail, columnOverrides) =>
  createColumnDefinitionBuilder({
    accessor: 'emailVerification',
    Header: <FormattedMessage {...messages.emailStatusColumnHeader} />,
    Cell: (props) => <EmailVerificationStatusCell {...props} onClickVerifyEmail={onClickVerifyEmail} />,
    width: 1,
  })(columnOverrides);
